import * as React from 'react';
const SvgMasonry = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={120}
    height={121}
    fill="none"
    viewBox="0 0 120 121"
    {...props}
  >
    <g clipPath="url(#a)">
      <circle cx={60} cy={60.5} r={60} fill="#E0EBFF" />
      <g filter="url(#b)" opacity={0.5}>
        <rect
          width={82.5}
          height={56.25}
          x={18.75}
          y={34.25}
          fill="#0014CC"
          rx={6}
        />
      </g>
      <path
        fill="#fff"
        d="M18.75 36.5a6 6 0 0 1 6-6h70.5a6 6 0 0 1 6 6v48a6 6 0 0 1-6 6h-70.5a6 6 0 0 1-6-6z"
      />
      <path fill="#85A3FF" d="M18.75 36.5a6 6 0 0 1 6-6h70.5a6 6 0 0 1 6 6z" />
      <rect width={21} height={21} x={24} y={41} fill="#0014CC" rx={4} />
      <path
        fill="#fff"
        d="M32.94 47.42a2.52 2.52 0 0 0-.36 5.015v.725a3.24 3.24 0 1 1 3.58-3.58h-.726a2.52 2.52 0 0 0-2.494-2.16m1.68 2.64a1.56 1.56 0 0 0-1.56 1.56v3.12c0 .862.698 1.56 1.56 1.56h3.12a1.56 1.56 0 0 0 1.56-1.56v-3.12a1.56 1.56 0 0 0-1.56-1.56zm-.84 1.56a.84.84 0 0 1 .84-.84h3.12a.84.84 0 0 1 .84.84v3.12a.84.84 0 0 1-.84.84h-3.12a.84.84 0 0 1-.84-.84z"
      />
      <rect width={21} height={4.5} x={24} y={65} fill="#C2D4FF" rx={1} />
      <rect width={21} height={4.5} x={49.5} y={65} fill="#C2D4FF" rx={1} />
      <rect width={21} height={4.5} x={75} y={65} fill="#C2D4FF" rx={1} />
      <rect width={21} height={12.75} x={24} y={72.5} fill="#E0EBFF" rx={1} />
      <rect width={21} height={12.75} x={49.5} y={72.5} fill="#E0EBFF" rx={1} />
      <rect width={21} height={12.75} x={75} y={72.5} fill="#E0EBFF" rx={1} />
      <rect width={21} height={21} x={49.5} y={41} fill="#0014CC" rx={4} />
      <rect width={21} height={21} x={75} y={41} fill="#0014CC" rx={4} />
      <path
        fill="#fff"
        d="M58.44 47.42a2.52 2.52 0 0 0-.36 5.015v.725a3.24 3.24 0 1 1 3.58-3.58h-.726a2.52 2.52 0 0 0-2.494-2.16m1.68 2.64a1.56 1.56 0 0 0-1.56 1.56v3.12c0 .862.698 1.56 1.56 1.56h3.12a1.56 1.56 0 0 0 1.56-1.56v-3.12a1.56 1.56 0 0 0-1.56-1.56zm-.84 1.56a.84.84 0 0 1 .84-.84h3.12a.84.84 0 0 1 .84.84v3.12a.84.84 0 0 1-.84.84h-3.12a.84.84 0 0 1-.84-.84zM83.94 47.42a2.52 2.52 0 0 0-.36 5.015v.725a3.24 3.24 0 1 1 3.58-3.58h-.726a2.52 2.52 0 0 0-2.494-2.16m1.68 2.64a1.56 1.56 0 0 0-1.56 1.56v3.12c0 .862.698 1.56 1.56 1.56h3.12a1.56 1.56 0 0 0 1.56-1.56v-3.12a1.56 1.56 0 0 0-1.56-1.56zm-.84 1.56a.84.84 0 0 1 .84-.84h3.12a.84.84 0 0 1 .84.84v3.12a.84.84 0 0 1-.84.84h-3.12a.84.84 0 0 1-.84-.84z"
      />
      <circle cx={10.096} cy={48.5} r={2.25} fill="#85A3FF" />
      <path
        fill="#85A3FF"
        d="M63.254 14.118c.333-1.234 2.16-1.234 2.492 0l.175.646c.12.449.492.794.962.896l.363.078a1.224 1.224 0 0 1 0 2.409l-.362.078c-.471.102-.843.447-.963.895l-.175.647c-.332 1.234-2.16 1.234-2.492 0l-.174-.647a1.26 1.26 0 0 0-.963-.895l-.363-.079a1.224 1.224 0 0 1 0-2.408l.363-.078c.47-.102.842-.447.963-.896z"
      />
      <circle cx={72.75} cy={22.48} r={1.5} fill="#0A2FFF" />
      <path
        fill="#0A2FFF"
        d="M52.985 103.772c.332-1.234 2.16-1.234 2.492 0l.174.646c.12.448.492.794.963.896l.363.078a1.224 1.224 0 0 1 0 2.408l-.363.079c-.47.102-.842.447-.963.895l-.174.647c-.333 1.234-2.16 1.234-2.492 0l-.175-.647a1.26 1.26 0 0 0-.963-.895l-.362-.079a1.224 1.224 0 0 1 0-2.408l.362-.078c.471-.102.843-.448.963-.896z"
      />
      <circle cx={73.846} cy={102.5} r={2.25} fill="#C2D4FF" />
    </g>
    <defs>
      <clipPath id="a">
        <rect width={120} height={120} y={0.5} fill="#fff" rx={60} />
      </clipPath>
      <filter
        id="b"
        width={108.5}
        height={82.25}
        x={5.75}
        y={21.25}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_1099_15355"
          stdDeviation={6.5}
        />
      </filter>
    </defs>
  </svg>
);
export default SvgMasonry;
